import { Tag } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import styled from 'styled-components'

const StyledTag = styled(Tag)`
  height: 30px;
  cursor: ${props => (props.pointer ? 'pointer' : '')};
  border: ${props => (props.bordered ? '1px solid #CCCFD6' : '0px')};
  background: #f2f3f5 !important;
  box-sizing: border-box;
  border-radius: 6px;
  padding: ${props => (props.padding ? props.padding : '7px 10px')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};

  margin-right: ${props => (props.marginright ? props.marginright : '8px')};
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  width: ${props => (props.width ? props.width : 'auto')};

  color: #808697 !important;
`
const CustomTag = ({
  background,
  border,
  message,
  color,
  colorType,
  textColor,
  bordered = false,
  width,
  padding,
  marginright,
  paddingTop,
  pointer = false,
}) => {
  return (
    <Flex alignCenter center>
      <StyledTag
        colortype={colorType}
        color={color}
        background={background}
        border={border}
        textcolor={textColor}
        bordered={bordered}
        width={width}
        padding={padding}
        marginright={marginright}
        paddingTop={paddingTop}
        pointer={pointer}
      >
        {message}
      </StyledTag>
    </Flex>
  )
}

export default CustomTag
